import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";
import { isRebrandingEnabled } from "@src/appV2/redesign/Rebranding/workerAppRebranding";

import {
  type OnboardingStepProps,
  type OnboardingStepWrapperProps,
} from "../OnboardingStepWrapper";
import { useSaveOnboardingStageEffect } from "../useSaveOnboardingStageEffect";
import { JobsEducationStepContent } from "./JobsEducationStepContent";

export function JobsEducationStep(
  props: Pick<OnboardingStepWrapperProps, "worker" | "progress" | "onBack" | "onNext" | "stage">
) {
  const { worker, onNext, stage } = props;

  // Save onboarding stage but don't use the standard wrapper (ProgressCarousel has its own header)
  useSaveOnboardingStageEffect({ worker, stage });

  const stepProps: OnboardingStepProps = {
    worker,
    stage,
    onNext,
  };

  return (
    <PageWrapper
      variant="tertiary"
      sx={(theme) => ({
        background: isRebrandingEnabled()
          ? theme.palette.background.tertiary
          : // eslint-disable-next-line cbh-rules/no-inline-gradient -- TODO: migrate to theme palette gradient
            `linear-gradient(to bottom, #e8f0f2 0%, #f5f3f1 30%, ${theme.palette.background.quaternary} 60%, ${theme.palette.background.quaternary} 100%)`,
      })}
    >
      <JobsEducationStepContent {...stepProps} />
    </PageWrapper>
  );
}
